{
  "name": "brainware-student-portal",
  "version": "3.1.2",
  "homepage": "/",
  "private": true,
  "dependencies": {
    "@floating-ui/react-dom": "^2.1.9",
    "@fullcalendar/react": "^7.1.3",
    "@reduxjs/toolkit": "^2.13.0",
    "@tanstack/react-table": "^9.3.1",
    "apexcharts": "^8.5.0",
    "axios": "^1.21.0",
    "classnames": "^2.5.1",
    "crypto-js": "^4.2.0",
    "dayjs": "^1.11.23",
    "formik": "^2.4.9",
    "framer-motion": "^14.7.0",
    "history": "^5.3.0",
    "i18next": "^26.5.11",
    "lodash": "^4.18.1",
    "prop-types": "^15.8.1",
    "quill-delta": "^5.1.0",
    "react": "^19.3.1",
    "react-apexcharts": "^2.1.1",
    "react-dom": "^19.3.1",
    "react-highlight-words": "^1.0.0",
    "react-i18next": "^17.1.9",
    "react-icons": "^5.7.0",
    "react-is": "^19.3.1",
    "react-modal": "^3.16.3",
    "react-number-format": "^5.4.5",
    "react-pdf": "^11.0.0",
    "react-portal": "^4.3.0",
    "react-quill-new": "^3.8.3",
    "react-redux": "^9.3.0",
    "react-router-dom": "^7.18.4",
    "react-select": "^5.10.2",
    "react-simple-maps": "^5.0.5",
    "react-syntax-highlighter": "^16.1.2",
    "react-tooltip": "^6.0.9",
    "recharts": "^3.10.1",
    "redux": "^5.0.1",
    "redux-persist": "^6.0.0",
    "temporal-polyfill": "^1.0.6",
    "yup": "^1.7.1"
  },
  "scripts": {
    "start": "vite --host 127.0.0.1",
    "build": "vite build",
    "build:prod": "vite build",
    "build:dev": "vite build --mode development",
    "preview": "vite preview --host 127.0.0.1",
    "test": "vitest run",
    "test:watch": "vitest",
    "lint": "eslint src --max-warnings=0"
  },
  "browserslist": {
    "production": [
      ">0.2%",
      "not dead",
      "not op_mini all"
    ],
    "development": [
      "last 1 chrome version",
      "last 1 firefox version",
      "last 1 safari version"
    ]
  },
  "devDependencies": {
    "@eslint/js": "^10.0.1",
    "@tailwindcss/postcss": "^4.3.3",
    "@tailwindcss/typography": "^0.5.20",
    "@vitejs/plugin-react": "^6.1.2",
    "eslint": "^10.13.0",
    "eslint-plugin-react-hooks": "^7.1.1",
    "globals": "^17.13.0",
    "jsdom": "^30.1.3",
    "postcss": "^8.5.32",
    "tailwindcss": "^4.3.3",
    "vite": "^8.3.5",
    "vitest": "^5.0.5"
  },
  "type": "module",
  "engines": {
    "node": ">=22.13.0"
  }
}
